import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeviceDetectorService } from 'ngx-device-detector';

import { ENVIRONMENT_TOKEN, isPWA } from '@rx-applications/shared/utils';
import { AppVersionService } from '@rx-applications/shared/data-access';
import { BrandingManagerService } from '@rx-applications/shared/branding/data-access';
import { IosModalComponent } from '@rx-applications/clientsite/shared/ui';
import { LocalStorageService } from 'ngx-webstorage';
import { IosModalClosedKey } from '@rx-applications/clientsite/shared/utils';

@Component({
  selector: 'rx-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  readonly #appVersion = inject(ENVIRONMENT_TOKEN).version;
  readonly shouldShowIosModal = inject(BrandingManagerService).getBrandAccess().shouldShowIosModal();

  @ViewChild('debugHelperContainer', { static: true, read: ViewContainerRef }) debugHelperContainer!: ViewContainerRef;

  title = 'rx-clientsite-ui';

  constructor(
    private deviceService: DeviceDetectorService,
    private modalService: NgbModal,
    private localStorageService: LocalStorageService,
    private readonly appVersionService: AppVersionService,
  ) {}

  ngOnInit(): void {
    this.appVersionService.bindToDOM('app-version', this.#appVersion);
  }

  ngAfterViewInit(): void {
    this.openIosModal();
  }

  private openIosModal() {
    const isIOS: boolean = this.deviceService.os === 'iOS' || this.deviceService.device === 'iPad';
    if (isIOS && !isPWA() && this.shouldShowIosModal && !this.localStorageService.retrieve(IosModalClosedKey)) {
      const iosModal = this.modalService.open(IosModalComponent, {
        size: 'lg',
        centered: false,
        windowClass: 'ios-pwa-modal',
      });
      iosModal.result.then(() => {
        this.localStorageService.store(IosModalClosedKey, true);
      });
    }
  }
}
